import { matchPath } from "react-router-dom";

/**
 * Whether `pathname` is a full AI Assistant page (a space's root or one of
 * its chats). Maya is already open there, so the sidebar stays shut and the
 * launcher just says so.
 */
export const isAssistantPage = (pathname: string, roots: string[]): boolean =>
  roots.some(
    (root) =>
      matchPath({ path: root, end: true }, pathname) !== null ||
      matchPath({ path: `${root}/:sessionId`, end: true }, pathname) !== null,
  );
